import { render } from "./FaqComponent.vue?vue&type=template&id=6c596f16"
import script from "./FaqComponent.vue?vue&type=script&lang=js"
export * from "./FaqComponent.vue?vue&type=script&lang=js"

import "./FaqComponent.vue?vue&type=style&index=0&id=6c596f16&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__